(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('StaysListController', StaysListController);
    

    StaysListController.$inject = [
        '$templateCache',
        'stayService',
        '$scope',
        '$rootScope',
        '$window',
        'notificationService',
        'simpleModalService',
        '$filter',
        '$state',
        'genericDataService',
        '$timeout',
        'common',
        'restrictionService'
    ];

    

    function StaysListController(
        $templateCache,
        stayService,
        $scope,
        $rootScope, 
        $window,
        notificationService,
        simpleModalService,
        $filter,
        $state,
        genericDataService,
        $timeout,
        common,
        restrictionService
    ) {
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
            var templates = {
				accionesCellTemplate: 
					$templateCache.get('app/views/tablesTemplates/stays/accionesCellTemplate.html'),
				headerTemplate: 
					$templateCache.get('app/views/tablesTemplates/stays/customHeaderTemplate.html'),
				editOrdenEntradaTemplate: 
					$templateCache.get('app/views/tablesTemplates/stays/editOrdenEntradaTemplate.html'),
				editOrdenSalidaTemplate: 
					$templateCache.get('app/views/tablesTemplates/stays/editOrdenSalidaTemplate.html'),
				rowTemplate:
				$templateCache.get('app/views/tablesTemplates/stays/rowTemplate.html'),
		 };


        var paginationOptions = {
            pageNumber: 1,
			pageSize: 25, 
			sort: { field: 'fentrada', direction: 'desc' }
        };
        var sorting = {
			field: 'fentrada',
			direction: 'desc'
        };

        var vm = this;
        vm.restrictionService = restrictionService; 

        vm.onDateRangeChange = onDateRangeChange;
        vm.dateRange = $.extend({}, common.defaultDateRangePickerOptions);

        vm.searchText = '';
        vm.clearSearcher = clearSearcher;

		vm.rootScope = $rootScope;
        vm.appliedFilters = [];
		$scope.gridData = [];
		vm.focusedRow = null;
		vm.mostrarDadosBaja = 0;
		vm.predefinedFilter = { name: 'Personalizado', filter: null };
		vm.refreshing = false;
		vm.loadingInformation = true;
		vm.filterControl = {}; //Used to call methods of the filter directive
        vm.frequencyFields = ['idBase', 'expediente', 'matricula'];


        vm.rowCount = 0;
        vm.firstLoaded = false;

		vm.gridOptions = {
			rowTemplate: templates.rowTemplate,
            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,
            useExternalSorting: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,
            primaryKey: 'estanciaId',
            columnDefs: [

                {
					name: 'idBase',
                    displayName: 'Base',
                    width: 65,
                    resizable: true
				},

				{
					field: 'fentrada',
					displayName: 'F.Entrada',
					width: 175,
					resizable: true,
					cellFilter: 'date: "dd/MM/yyyy HH:mm"',
					sort: { priority: 1, direction: 'desc' },
					headerCellTemplate: templates.headerTemplate,
					cellTemplate: templates.editOrdenEntradaTemplate
				},
				{
					field: 'fsalida',
					displayName: 'F.Salida',
					width: 175,
					resizable: true,
					cellFilter: 'date: "dd/MM/yyyy HH:mm"',
					headerCellTemplate: templates.headerTemplate,
					cellTemplate: templates.editOrdenSalidaTemplate
				},

				{
					field: 'expediente',
					displayName: 'Expediente',
					minWidth: 90,
					maxWidth: 150,
					resizable: true,
					headerCellTemplate: templates.headerTemplate,
				},

				{
					field: 'matricula',
					displayName: 'Matricula',
					minWidth: 90,
					maxWidth: 150,
					resizable: true,
					headerCellTemplate: templates.headerTemplate
				},

				{
					field: 'marca',
					displayName: 'Marca',
					minWidth: 90,
					maxWidth: 150,
					resizable: true,
					headerCellTemplate: templates.headerTemplate
				},

				{
					field: 'modelo',
					displayName: 'Modelo',
					minWidth: 90,
					maxWidth: 150,
					resizable: true,
					headerCellTemplate: templates.headerTemplate
				},

				{
					field: 'color',
					displayName: 'Color',
					minWidth: 90,
					maxWidth: 150,
					resizable: true,
					headerCellTemplate: templates.headerTemplate
				},

				{
					field: 'observaciones',
					displayName: 'Observaciones',
					resizable: true,
					headerCellTemplate: templates.headerTemplate
				},

				{
					field: 'numDias',
                    cellClass: 'strong', 
					displayName: 'Días', 
					width: 65,
					resizable: true,
					headerCellTemplate: templates.headerTemplate,
				},

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    width: 90,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate
                }

             ],
             data: 'gridData',
             onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll= false;

                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if(sortColumns.length > 0){
                        sorting.field = sortColumns[0].field;
                        sorting.direction = sortColumns[0].sort.direction;
                    }else{
                        sorting = {field: null, direction: null};
                    }

                    loadData();
                });
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;

                    loadData();
                });
            }
        };

		 vm.fields = [
			 //Default filters to appear
			 { default: true, display: 'Expediente', type: 'string', field: 'expediente' },
			 { default: true, display: 'Matrícula', type: 'string', field: 'matricula' },
			 { default: true, display: 'Base', type: 'string', field: 'idBase' },
			 { default: true, display: 'F.Entrada', type: 'date', field: 'fentrada' },
			 { default: true, display: 'F.Salida', type: 'date', field: 'fsalida' },
			 //Rest of possible filters
			 { display: 'Marca', type: 'string', field: 'marca' },
			 { display: 'Modelo', type: 'string', field: 'modelo' },
		];

        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
		vm.showHideFilterBar = showHideFilterBar;
		vm.refreshData = refreshData;
		vm.applyFilter = applyFilter;
		vm.filterChange = filterChange; 
		vm.remove = remove;
		vm.removeAllEstancias = removeAllEstancias;
		vm.goToEdit = goToEdit;
		vm.goToEditOrden = goToEditOrden;
		vm.deleteSearchData = deleteSearchData;

		vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('estancias')];

        (function () {
			var state = $rootScope.stateStorage[vm.tab.name];
			if (state && vm.tab.keepState) {
				vm.focusedRow = state.focusedRow || null;
			}
			//$timeout(function () {
			//	var f = vm.filterControl.getFilters();
			//	f.push({
			//		default: false,
			//		display: 'F.Entrada',
			//		field: 'fentrada',
			//		id: 'hoy',
			//		type: 'date'
			//	});
			//	vm.filterControl.setPredefinedFilters(f);
			//}, 0);

          loadData();
        })();
 
        function loadData(success) {
            var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            var take = paginationOptions.pageSize;
            vm.loadingInformation = false;
            stayService.getList(skip, take, sorting, vm.appliedFilters, vm.mostrarDadosBaja ? 1 : 0, vm.frequencyFields, vm.searchText, vm.dateRange.fromDate, vm.dateRange.toDate)
                .then(function (result) {

                    vm.gridOptions.totalItems = result.data.count;
                    $scope.gridData = result.data.list;
                    vm.loadingInformation = true;
                    vm.rowCount = vm.gridOptions.totalItems;
                    vm.firstLoaded = true;

                    vm.refreshing = false;
                    if (success) {
	                    notificationService.sendAppNotification({
		                    message: 'Estancia eliminada con éxito',
		                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
	                    });
                    }
                    //Mantain the selected row after loading the new data
                    var selected = vm.gridApi.selection.getSelectedRows();
                    vm.clearAll();
                    for (var i = 0; i < $scope.gridData.length; i++) {
	                    var found = $filter('filter')(selected, { 'estanciaId': $scope.gridData[i].estanciaId });
	                    if (found[0]) {
		                    vm.gridApi.grid.modifyRows($scope.gridData);
		                    vm.gridApi.selection.selectRow($scope.gridData[i]);
	                    }
                    }
                    vm.loadingInformation = true;
            });
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }
        function clearAll() {
            vm.gridApi.selection.clearSelectedRows();
        }
        function invertSelection(){
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for(var i = 0; i < selected.length; i++){
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }
        function selectOrClear(){
            if(vm.gridApi.selection.getSelectAllState()){
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }
        function showHideFilterBar(){
			vm.filtersSidebar = !vm.filtersSidebar;
			if (!vm.filtersSidebar) { vm.filterControl.clearModifiedFilters(); }
			$rootScope.$broadcast('detail-resize');
		}

        function refreshData(success) {
            
			vm.refreshing = true;
			loadData(success);
        }

        function clearSearcher() {
            vm.searchText = '';
            refreshData();
        }

		function applyFilter(filters) {
            vm.appliedFilters = filters;            
			loadData();
		}
        
		function filterChange() {
			vm.predefinedFilter = { name: 'Personalizado', filter: null };
		}

        function remove(estancia) {
            if (!restrictionService.hasPermission('eliminar', 'estancia')) return; 

			if (estancia == null) { return; }
			simpleModalService.yesNoModal('Confirmación eliminar', '¿Desea eliminar la estancia?')
				.then(function (result) {
					if (result) {
						notificationService.sendAppNotification({
							message: 'Eliminando ordenes...',
							positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
						});
						stayService.removeEstancias([estancia]).then(function () {
							refreshData(true);
						}, function () {
							notificationService.sendAppNotification({
								message: 'Ha ocurrido un error al eliminar las estancias',
								positionY: 'top', positionX: 'right', delay: null, type: 'error'
							});
						});
					}
				});
		}

        function removeAllEstancias() {
            if (!restrictionService.hasPermission('eliminar', 'estancia')) return; 

			simpleModalService.yesNoModal('Confirmación eliminar',
				'¿Desea eliminar las ' + vm.gridApi.selection.getSelectedCount() + ' estancias seleccionadas?')
				.then(function (result) {
					if (result) {
						var estanciasIds = [];
						var selected = vm.gridApi.selection.getSelectedRows();
						for (var i = 0; i < selected.length; i++) {
							estanciasIds.push(selected[i].estanciaId);
						}
						notificationService.sendAppNotification({
							message: 'Eliminando estancias...',
							positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
						});
						stayService.removeEstancias(estanciasIds)
							.then(function () {
								refreshData(true);
							},
							function () {
								notificationService.sendAppNotification({
									message: 'Ha ocurrido un error al eliminar las estancias',
									positionY: 'top', positionX: 'right', delay: null, type: 'error'
								});
							});
					}
				});

		}

		function goToEdit(estanciaId) {
            vm.focusedRow = estanciaId;
            restrictionService.hasPermission('modificar', 'estancia', 'flota.estancias.editar', { 'id': estanciaId });

			//$state.go('flota.estancias.editar', { 'id': estanciaId });
		}

		function goToEditOrden(ordenId) {
			var allOrdersOpen = null;
			if (vm.rootScope.tabManager.indexOfName('ordenes') !== -1) {
				allOrdersOpen = true;
			}
			$state.go('flota.ordenes.editar', { 'id': ordenId, 'allOrdersOpen': allOrdersOpen });
		}

		$scope.$on('$destroy', function () { //Save state
			$rootScope.stateStorage[vm.tab.name] = {
				focusedRow: vm.focusedRow
			};
		}); 

		function deleteSearchData() {
			vm.searchText = '';
        }

        function onDateRangeChange() {
            refreshData();
        }
    }

})();